// statuses
export const STATUS = {
  FOR_PRE_EVALUATION: {
    value: 'FOR PRE-EVALUATION',
    classLg: ' bg-gray-300 text-black text-sm rounded text-center py-3',
    classSm: ' text-sm bg-gray-300 text-black px-2 w-auto py-1 rounded',
    remarks: 'Waiting fo Approval Result'
  },
  FOR_ASSESSMENT: {
    value: 'FOR ASSESSMENT',
    classLg: ' bg-gray-300 text-black text-sm rounded text-center py-3',
    classSm: ' text-sm bg-gray-300 text-black px-2 w-auto py-1 rounded',
    remarks: 'Waiting fo Approval Result'
  },
  FOR_APPEARANCE: {
    value: 'FOR APPEARANCE',
    classLg: ' bg-info text-white text-sm rounded text-center py-3',
    classSm: ' text-sm bg-info text-white px-2 w-auto py-1 rounded',
    remarks: 'Waiting fo Approval Result'
  },
  FOR_APPOINTMENT: {
    value: 'FOR APPOINTMENT',
    classLg: ' bg-warning text-black text-sm rounded text-center py-3',
    classSm: ' text-sm bg-warning text-black px-2 w-auto py-1 rounded',
    remarks: 'Schedule to Bring Hard Copies'
  },
  FOR_RESUBMISSION: {
    value: 'FOR RESUBMISSION',
    classLg: ' bg-red-600 text-white text-sm rounded text-center py-3',
    classSm: ' text-sm bg-red-600 text-white px-2 w-auto py-1 rounded',
    remarks: 'Review and resubmit your application'
  },
  FOR_PAYMENT: {
    value: 'FOR PAYMENT',
    classLg: ' bg-primary text-white text-sm rounded text-center py-3',
    classSm: ' text-sm bg-primary text-white px-2 w-auto py-1 rounded',
    remarks: 'Review and resubmit your application'
  },
  WAITING_FOR_PAYMENT: {
    value: 'WAITING FOR PAYMENT',
    classLg: ' bg-primary text-white text-sm rounded text-center py-3',
    classSm: ' text-sm bg-primary text-white px-2 w-auto py-1 rounded',
    remarks: 'Review and resubmit your application'
  },
  APPROVED: {
    value: 'APPROVED',
    classLg: ' bg-primary text-white text-sm rounded text-center py-3',
    classSm: ' text-sm bg-primary text-white px-2 w-auto py-1 rounded',
    remarks: 'Review and resubmit your application'
  },
  PAID: {
    value: 'PAID',
    classLg: ' bg-success text-white text-sm rounded text-center py-3',
    classSm: ' text-sm bg-success text-white px-2 w-auto py-1 rounded',
    remarks: 'Review and resubmit your application'
  },
  FOR_HEARING: {
    value: 'FOR HEARING',
    classLg: ' bg-red-600 text-white text-sm rounded text-center py-3',
    classSm: ' text-sm bg-red-600 text-white px-2 w-auto py-1 rounded',
    remarks: 'Review and resubmit your application'
  },
  FOR_CPC_DECISION: {
    value: 'FOR CPC DECISION',
    new_value: 'FOR RESOLUTION',
    classLg: ' bg-warning text-black text-sm rounded text-center py-3',
    classSm: ' text-sm bg-warning text-black px-2 w-auto py-1 rounded justify-center items-center',
    classXm: ' text-xs bg-warning text-black px-2 w-auto py-1 rounded justify-center items-center',
    remarks: 'Your application is for resolution'
  },
  PENDING: {
    value: 'PENDING',
    classLg: ' bg-warning text-black text-sm rounded text-center py-3',
    classSm: ' text-sm bg-warning text-black px-2 w-auto py-1 rounded',
    remarks: 'Schedule to Bring Hard Copies'
  },
  FOR_PRINTING: {
    value: 'FOR PRINTING',
    new_value: 'FOR RESOLUTION',
    classLg: ' bg-success text-white text-sm rounded text-center py-3',
    classSm: ' text-sm bg-success text-white px-2 w-auto py-1 rounded',
    remarks: 'Review and resubmit your application'
  },
  FOR_RELEASE: {
    value: 'FOR RELEASE',
    classLg: ' bg-success text-white text-sm rounded text-center py-3',
    classSm: ' text-sm bg-success text-white px-2 w-auto py-1 rounded',
    remarks: 'Review and resubmit your application'
  },
  RELEASED: {
    value: 'RELEASED',
    classLg: ' bg-success text-white text-sm rounded text-center py-3',
    classSm: ' text-sm bg-success text-white px-2 w-auto py-1 rounded',
    remarks: 'Review and resubmit your application'
  },
  FOR_BOARD_1: {
    value: 'FOR BOARD 1',
    new_value: 'FOR RESOLUTION',
    classLg: ' bg-warning text-black text-sm rounded text-center py-3',
    classSm: ' text-sm bg-warning text-black px-2 w-auto py-1 rounded justify-center items-center',
    classXm: ' text-xs bg-warning text-black px-2 w-auto py-1 rounded justify-center items-center',
    remarks: 'Your application is for resolution'
  },
  FOR_BOARD_2: {
    value: 'FOR BOARD 2',
    new_value: 'FOR RESOLUTION',
    classLg: ' bg-warning text-black text-sm rounded text-center py-3',
    classSm: ' text-sm bg-warning text-black px-2 w-auto py-1 rounded justify-center items-center',
    classXm: ' text-xs bg-warning text-black px-2 w-auto py-1 rounded justify-center items-center',
    remarks: 'Your application is for resolution'
  },
  FOR_BOARD_3: {
    value: 'FOR BOARD 3',
    new_value: 'FOR RESOLUTION',
    classLg: ' bg-warning text-black text-sm rounded text-center py-3',
    classSm: ' text-sm bg-warning text-black px-2 w-auto py-1 rounded justify-center items-center',
    classXm: ' text-xs bg-warning text-black px-2 w-auto py-1 rounded justify-center items-center',
    remarks: 'Your application is for resolution'
  },
  APPLICATION_RECEIVED: {
    value: 'APPLICATION RECEIVED',
    classLg: ' bg-success text-white text-sm rounded text-center py-3',
    classSm: ' text-sm bg-success text-white px-2 w-auto py-1 rounded',
    remarks: 'Application Received'
  },
  FOR_ED_APPROVAL: {
    value: 'FOR ED APPROVAL',
    classLg: ' bg-warning text-black text-sm rounded text-center py-3',
    classSm: ' text-sm bg-warning text-black px-2 w-auto py-1 rounded',
    remarks: 'Your application is for ED approval'
  },
}

export const EXTENSION_NAME_OPTIONS = [
  {
    label: 'SR.',
    value: 'SR.',
  },
  {
    label: 'JR.',
    value: 'JR.',
  },
  {
    label: 'II',
    value: 'II',
  },
  {
    label: 'III',
    value: 'III',
  },
  {
    label: 'IV',
    value: 'IV',
  },
  {
    label: 'V',
    value: 'V',
  },
  {
    label: 'VI',
    value: 'VI',
  },
  {
    label: 'VII',
    value: 'VII',
  },
  {
    label: 'VIII',
    value: 'VIII',
  },
  {
    label: 'IX',
    value: 'IX',
  },
  {
    label: 'X',
    value: 'X',
  }
]


export const GENDER_OPTIONS = [
  {
    label: 'FEMALE',
    value: 'FEMALE',
  },
  {
    label: 'MALE',
    value: 'MALE',
  }
]



export const TYPE_OF_SERVICE_OPTIONS = [
  {
    label: 'PUJ',
    value: 'PUJ',
  },
  {
    label: 'TH',
    value: 'TH',
  },
  {
    label: 'TTS',
    value: 'TTS',
  },
  {
    label: 'SB',
    value: 'SB',
  },
  {
    label: 'TX',
    value: 'TX',
  },
  {
    label: 'SHS',
    value: 'SHS',
  },
  {
    label: 'AUV',
    value: 'AUV',
  },
  {
    label: 'PUB_AC_REG',
    value: 'PUB_AC_REG',
  }
]


export const TRANSACTION_TYPE_OPTIONS = [
  {
    label: 'New',
    value: 'New',
  },
  {
    label: 'Renewal',
    value: 'Renewal',
  }
]


export const TYPE_OF_OWNERSHIP_OPTIONS = [
  {
    label: 'Single Propriertorship',
    value: 'Single Propriertorship',
  },
  {
    label: 'Corporation',
    value: 'Corporation',
  },
  {
    label: 'Partnership',
    value: 'Partnership',
  },
  {
    label: 'Cooperative',
    value: 'Cooperative',
  }
]